import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class TipoDestinatarioService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerTodos(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        {
          tipo_destinatario {
            obtenerTodos {
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        }
        `,
        variables: {},
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.tipo_destinatario.obtenerTodos
        callback({ mensajes, respuesta })
      }
    );
  }

  ObtenerDestinatariosSegunOrigen(inputParams: {
    maq: {empresa_rut:number, numero_placa: string},
    paginaActual: number,
    cantidadRegistrosxPagina:number
  }, callback: Function) {
  this.gqlclient.query(
    {
      query: gql`
      query ($maq:maquinaInputType, $paginaActual:Int, $cantidadRegistrosxPagina:Int){
        tipo_destinatario {
          obtenerDestinatarios (
            maquina: $maq,
            paginaActual: $paginaActual,
            cantidadRegistrosPorPagina:$cantidadRegistrosxPagina
          ){
            respuesta {
              registros {
                codigo
                nombre
                descripcion

              }

            }

          }

        }
      }
      `,
      variables: inputParams,
      fetchPolicy: 'no-cache',
    },
    function (response) {

      console.log(response)

      const { mensajes, respuesta } = response.data.tipo_destinatario.obtenerDestinatarios;
      callback({ mensajes, respuesta })
    }
  );
  }
}
